import { atom } from 'recoil'
import { GetAgentActivityResponse } from 'common/src/api/contentFrontendVsContentBackend/agentContent'
import { getAgentActivity } from '@/api/cb/agentContent'

const ACTIVITY_POLL_INTERVAL_MS = 10_000

export const agentActivityAtom = atom<GetAgentActivityResponse | null>({
    key: 'agentActivityAtom',
    default: null,
    effects: [
        ({ setSelf }) => {
            if (typeof window === 'undefined') return
            let isActive = true
            const refresh = async (): Promise<void> => {
                const response = await getAgentActivity()
                if (isActive && response.data.success) {
                    setSelf(response.data.payload)
                }
            }
            void refresh()
            const interval = window.setInterval(
                (): void => void refresh(),
                ACTIVITY_POLL_INTERVAL_MS
            )
            return () => {
                isActive = false
                window.clearInterval(interval)
            }
        },
    ],
})
